import axios from 'axios'

const PRELEAD_URL = process.env.REACT_APP_PRE_LEAD_LAMBDA_URL

export function getGoogleClientId(): string {
  const urlParam = new URLSearchParams(window.location.search).get('leadClientIDGoogle')
  if (urlParam) return urlParam

  return (
    document.cookie
      .split('; ')
      .find(row => row.startsWith('_ga='))
      ?.split('=')[1] ?? ''
  )
}

export function upsertPreLeadObject(data: Record<string, unknown>): void {
  const leadClientIDGoogle =
    (data.leadClientIDGoogle as string) || getGoogleClientId()
  if (!leadClientIDGoogle || !PRELEAD_URL) return

  axios.post(PRELEAD_URL, { ...data, leadClientIDGoogle }).catch(() => {})
}
